import { SITE, STATS } from '../config/site';

export default function StatsBar({ creative = false }) {
  return (
    <div className={`stats-bar${creative ? ' stats-bar--creative' : ''}`}>
      <div className="container">
        <p className="stats-bar__tagline">
          <span aria-hidden="true">🇮🇳</span> {SITE.handcraftedTagline}
        </p>
        <div className="stats-bar__inner">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="stats-bar__item"
              style={{ '--stat-accent': stat.accent }}
            >
              <span className="stats-bar__value">{stat.value}</span>
              <span className="stats-bar__label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
